var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUzbekistn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7555 11.4008C0.265375 12.9363 -6.2489e-05 14.5721 1.10347e-08 16.2701C-6.2489e-05 17.9683 0.265437 19.6042 0.755562 21.1397L16 21.8355L31.2444 21.1398C31.7345 19.6043 32.0001 17.9683 32.0001 16.2703C32 14.5721 31.7346 12.9363 31.2444 11.4007L16 10.7051L0.7555 11.4008Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2439 11.4012L15.9995 10.7056L0.755008 11.4012C0.609758 11.8564 0.484695 12.3206 0.379883 12.7925H31.6189C31.5142 12.3206 31.3892 11.8563 31.2439 11.4012Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.380066 19.749C0.484753 20.2209 0.609816 20.685 0.755066 21.1403L0.756566 21.1403L15.9994 21.836L31.2439 21.1403C31.3891 20.6851 31.5142 20.2209 31.6189 19.749H0.380066Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.2706C23.1387 32.2706 29.1844 27.5954 31.2447 21.1401H0.755859C2.81617 27.5953 8.86192 32.2706 16.0002 32.2706Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.270508C8.86192 0.27057 2.8163 4.94576 0.755859 11.4009L31.2447 11.401C29.1845 4.94569 23.1388 0.270445 16.0003 0.270508Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31135 6.8794C7.31135 5.38084 8.36454 4.12896 9.77098 3.82184C9.55485 3.77459 9.33054 3.74902 9.10016 3.74902C7.37129 3.74902 5.96973 5.15052 5.96973 6.87946C5.96973 8.6084 7.37116 10.0099 9.10016 10.0099C9.33054 10.0099 9.55479 9.98427 9.77098 9.93709C8.3646 9.62984 7.31135 8.37796 7.31135 6.8794Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6212 8.30225L11.8331 8.95443H12.5189L11.9641 9.35756L12.176 10.0097L11.6212 9.60668L11.0664 10.0097L11.2783 9.35756L10.7235 8.95443H11.4092L11.6212 8.30225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.81 8.30225L14.0219 8.95443H14.7077L14.1529 9.35756L14.3648 10.0097L13.81 9.60668L13.2552 10.0097L13.4671 9.35756L12.9124 8.95443H13.598L13.81 8.30225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 8.30273L16.2102 8.95492H16.896L16.3412 9.35805L16.5531 10.0102L15.9983 9.60717L15.4435 10.0102L15.6555 9.35805L15.1006 8.95492H15.7864L15.9983 8.30273Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1876 8.30225L18.3995 8.95443H19.0852L18.5305 9.35756L18.7424 10.0097L18.1876 9.60668L17.6327 10.0097L17.8447 9.35756L17.2899 8.95443H17.9756L18.1876 8.30225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3764 8.30225L20.5883 8.95443H21.274L20.7193 9.35756L20.9312 10.0097L20.3764 9.60668L19.8215 10.0097L20.0335 9.35756L19.4787 8.95443H20.1644L20.3764 8.30225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.81 6.02588L14.0219 6.678H14.7077L14.1529 7.08119L14.3648 7.73332L13.81 7.33025L13.2552 7.73332L13.4671 7.08119L12.9124 6.678H13.598L13.81 6.02588Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 6.02588L16.2102 6.678H16.896L16.3412 7.08119L16.5531 7.73332L15.9983 7.33025L15.4435 7.73332L15.6555 7.08119L15.1006 6.678H15.7864L15.9983 6.02588Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1876 6.02588L18.3995 6.678H19.0852L18.5305 7.08119L18.7424 7.73332L18.1876 7.33025L17.6327 7.73332L17.8447 7.08119L17.2899 6.678H17.9756L18.1876 6.02588Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3764 6.02588L20.5883 6.678H21.274L20.7193 7.08119L20.9312 7.73332L20.3764 7.33025L19.8215 7.73332L20.0335 7.08119L19.4787 6.678H20.1644L20.3764 6.02588Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 3.74902L16.2102 4.40127H16.896L16.3412 4.80434L16.5531 5.45659L15.9983 5.05352L15.4435 5.45659L15.6555 4.80434L15.1006 4.40127H15.7864L15.9983 3.74902Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1876 3.74902L18.3995 4.40127H19.0852L18.5305 4.80434L18.7424 5.45659L18.1876 5.05352L17.6327 5.45659L17.8447 4.80434L17.2899 4.40127H17.9756L18.1876 3.74902Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3764 3.74902L20.5883 4.40127H21.274L20.7193 4.80434L20.9312 5.45659L20.3764 5.05352L19.8215 5.45659L20.0335 4.80434L19.4787 4.40127H20.1644L20.3764 3.74902Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUzbekistn);
export default __webpack_public_path__ + "static/media/flag_uzbekistán.e72d1eb29d411decb576197c22dffa77.svg";
export { ForwardRef as ReactComponent };